<template>
<div class="content">
    <div class="container-fluid">
    <div class="row">
        <div class="col-md-12">
        <edit-responsibility>
        </edit-responsibility> 
        </div>
    </div>  
    </div>
</div>
</template>
<script>
/* eslint-disable */
import editResponsibility from './todo-edit-responsibility'
export default {
    components: {
        editResponsibility
    }
}
</script>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-responsibility-form/base-edit-responsibility.vue